import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AuthService } from '../../services';
import { MemberService } from '../../services/member.service';

@Component({
  selector: 'app-mobile-bottom-tabs',
  templateUrl: './mobile-bottom-tabs.component.html',
  styleUrls: ['./mobile-bottom-tabs.component.scss']
})
export class MobileBottomTabsComponent implements OnInit {
  user: any = {};
  member: any = {};
  notifications: any[] = [];

  constructor(
    private afs: AngularFirestore,
    private authService: AuthService,
    private memberService: MemberService

  ) {
  }

  async ngOnInit() {
    const userClaims = await this.authService.getUserCustomClaims();
    userClaims.member =
      this.user = userClaims.user.multiFactor.user;
    this.member = await this.memberService.getByProperty(
      'email',
      this.user.email
    );

    this.getNotifications()
  }

  async getNotifications() {
    this.afs.collection('members').doc(this.member.docId).collection('notifications', ref => {
      return ref.where('read', '==', false);
    }).snapshotChanges().subscribe((snapshot) => {
      this.notifications = snapshot.map(sn => {
        return { ...sn.payload.doc.data(), docId: sn.payload.doc.id }
      });
    })
  }

}
